import * as React from 'react'
import { SITE_TITLE_PLACEHOLDER } from '../../../utils/constants'

type LogoProps = React.PropsWithChildren<{
    className?: string
}>

export const Logo: React.FC<LogoProps> = ({ className }) => {
    return (
        <img
            data-testid="logo"
            src="/assets/logo.png"
            alt={SITE_TITLE_PLACEHOLDER}
            className={className}
        />
    )
}
